import { type CryptoPaymentData } from '@app/client/common/structs/orders/cart';

export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const SET_PURCHASED_AMOUNT = 'SET_PURCHASED_AMOUNT';
export const ACTION_RESET_CRYPTO_STORE = 'ACTION_RESET_CRYPTO_STORE';

interface SetPaymentMethods {
    type: typeof SET_PAYMENT_METHODS;
    payload: CryptoPaymentData[];
}

interface SetPurchasedAmount {
    type: typeof SET_PURCHASED_AMOUNT;
    payload: { actualAmount: number; amount: number };
}

interface ResetCryptoStoreAction {
    type: typeof ACTION_RESET_CRYPTO_STORE;
}

export type CryptoActionTypes = SetPaymentMethods | SetPurchasedAmount | ResetCryptoStoreAction;
